<mat-tab-group style="height:  calc(100% - 30px);">
    <mat-tab label="Rapid Files (ZOHO)">
        <app-rapid-files-zoho></app-rapid-files-zoho>
    </mat-tab>
    <mat-tab label="Rapid Files (Portal)">
        <app-rapid-files-portal></app-rapid-files-portal>
    </mat-tab>
</mat-tab-group>